import { useMemo } from 'react';
import { useDispatch } from 'src/store';
import { actions, content } from 'src/store/navbar';

export const usePromoActions = () => {
  const dispatch = useDispatch();

  return useMemo(
    () => ({
      show: () => {
        dispatch(actions.showPromo());
      },
      hide: () => {
        dispatch(actions.hidePromo());
      },
      expand: () => {
        dispatch(actions.expandPromo());
      },
      collapse: () => {
        dispatch(actions.collapsePromo());
      },
      setSpacer: content.setPromoSpacer,
    }),
    [dispatch]
  );
};
